import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { LoadingService } from "src/app/core/services/ui/loading.service";
import { fromEvent } from "rxjs";
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import { CollisService } from "../../../core/services/collis/collis.service";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { VoyageService } from "src/app/core/services/voyage/voyage.service";
import { TypevoyageService } from "../../../core/services/typevoyage/typevoyage.service";
import { MatDialogRef } from "@angular/material/dialog";
import { ReservationService } from "../../../core/services/reservation/reservation.service";


@Component({
  selector: "app-reservationmodal",
  templateUrl: "./reservationmodal.component.html",
  styleUrls: ["./reservationmodal.component.css"],
})
export class ReservationmodalComponent implements OnInit {
  ldate: any;
  cat: any;

  @HostListener('document:keypress', ['$event'])
keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if(this.passagerForm.invalid){
        return;
      }
        this.createreservation();
    }
}

  @ViewChild('searchprimarynumber') searchInputprimary: ElementRef;
  @ViewChild('searchprimaryname') searchInputname: ElementRef;

  passagerForm: any;
  amountpassager: any;
  numberpassager: any;
  lastprintstate: boolean;
  customername: any;
  customerphone: any;
  destinations: any;
  base64: any;
  ticket: any;
  agence: any;
  voyageList: any;
  typevoyagelist: any;
  mintarif: any = 3500;
  maxplace: any;
  datelist: any;

  constructor(
    private dialogref: MatDialogRef<ReservationmodalComponent>,
    private formBuilder: FormBuilder,
    private loader: LoadingService,
    private collisservice: CollisService,
    private datepipe: DatePipe,
    private toastrService: ToastrService,
    private voyageservice: VoyageService,
    private typevoyageservice: TypevoyageService,
    private reservationService: ReservationService
  ) {
    this.lastprintstate = false;
    this.searchInputprimary = {} as ElementRef;
    this.searchInputname = {} as ElementRef;

    this.lastprintstate = false;
    this.agence = localStorage.getItem("agenceinso");
    this.agence = this.agence != null ? JSON.parse(this.agence) : null;
  }

  ngOnInit(): void {
    this.getdate();

    // this.getlogo();
    this.getvoyage();
    this.gettypevoyage();

    this.passagerForm = this.formBuilder.group({
      idreservation: [],
      ville: [""],
      place: ["", [Validators.max(this.maxplace)]],
      tarif: [""],
      contact: ["", [Validators.required]],
      montant: ["", []],
      nomclient: ["", [Validators.required]],
      cni: ["", []],
      reste: [0],
      idtypevoyage: [1, []],
      idvoyage: [""],
      iddestination: ["", [Validators.required]],
      passager: [""],
      sessionid: [localStorage.getItem("session")],
      category: [""],
    });

    this.montant.valueChanges.subscribe((data: any) => {
      // this.total = Number(this.tarif.value) + Number(data);
      if (Number(this.montant.value) > Number(this.tarif.value)) {
        this.reste.setValue(
          Number(this.montant.value) - Number(this.tarif.value)
        );
      }
    });
  }
  loading$ = this.loader.loading$;

  createreservation(): any {
    this.reservationService.savereservation(this.passagerForm.value).subscribe(
      (response: any) => {
        this.close();
      },
      (error: any) => {
      }
    );
  }

  filtertarifydestiantionandstatus(data: any): any {}

  ngAfterViewInit(): any {
    fromEvent<any>(this.searchInputprimary.nativeElement, "keyup")
      .pipe(
        map((event) => event.target.value),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchParam) =>
          this.collisservice.searchcustomerbynumber(searchParam.trim())
        )
      )
      .subscribe((searchResults: any) => {
        this.customerphone = searchResults;
      });

    fromEvent<any>(this.searchInputname.nativeElement, "keyup")
      .pipe(
        map((event) => event.target.value),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchParam) =>
          this.collisservice.searchcustomerbyname(searchParam.trim())
        )
      )
      .subscribe((searchResults: any) => {
        this.customername = searchResults;
      });
  }

  get montant(): any {
    return this.passagerForm.get("montant");
  }

  get place(): any {
    return this.passagerForm.get("place");
  }

  get typevoyage(): any {
    return this.passagerForm.get("idtypevoyage");
  }

  get contact(): any {
    return this.passagerForm.get("contact");
  }

  get cni(): any {
    return this.passagerForm.get("cni");
  }

  get nompassager(): any {
    return this.passagerForm.get("nomclient");
  }

  get reste(): any {
    return this.passagerForm.get("reste");
  }

  get tarif(): any {
    return this.passagerForm.get("tarif");
  }

  get passager(): any {
    return this.passagerForm.get("passager");
  }

  get voyage(): any {
    return this.passagerForm.get("idvoyage");
  }

  get destination(): any {
    return this.passagerForm.get("iddestination");
  }

  get category(): any {
    return this.passagerForm.get("category");
  }

  resetform(): any {}

  numbersonly(val: any): any {
    const control = this.passagerForm.controls["contact"];
    if (control?.value) {
      control.patchValue(control.value.replace(/[^0-9]/g, ""));
    }
  }

  numbersonly2(val: any): any {
    const control = this.passagerForm.controls["montant"];
    if (control?.value) {
      control.patchValue(control.value.replace(/[^0-9]/g, ""));
    }
  }

  numbersonly3(val: any): any {
    const control = this.passagerForm.controls["reste"];
    if (control?.value) {
      control.patchValue(control.value.replace(/[^0-9]/g, ""));
    }
  }

  fillnumber(val: any, name: any): any {
    this.contact.setValue(val.contact);
    if (val.customerDTO.length === 1) {
      this.nompassager.setValue(val.customerDTO[0].name);
    } else {
      this.nompassager.setValue(name);
    }
  }

  fillnameNumber(val: any, pnumber: any): any {
    if (val.phoneDTO.length === 1) {
      this.contact.setValue(val.phoneDTO[0].contact);
    } else {
      this.contact.setValue(pnumber);
    }
  }

  getvoyage() {
    this.voyageservice.getVoyagelist().subscribe((response: any) => {
      this.voyageList = response;
    });
  }

  tripdestination(dest: any): any {
    this.destinations = dest.destination;
    this.tarif.setValue(dest.tarif.tarif);
    this.montant.setValue(dest.tarif.tarif);
    this.mintarif = dest.tarif.tarif;
    this.category.setValue(dest.category.nomcategory);
  }

  getdate(): any {
    this.voyageservice.getvoyageDate().subscribe((response: any) => {
      this.datelist = response;
    });
  }

  getTripDestination(event: any): any {}

  gettypevoyage(): any {
    this.typevoyageservice.getTypeVoyagelist().subscribe((response: any) => {
      this.typevoyagelist = response;
    });
  }

  filterVoyagecat(event: any): any {
    this.cat = event.value;
    this.voyageservice
      .filterVoyageBydateAndCategory(this.ldate, this.cat)
      .subscribe((response: any) => {
        this.voyageList = response;
      });
  }

  filterVoyage(event: any): any {
    this.ldate = event.value;
    this.voyageservice
      .filterVoyageBydateAndCategory(this.ldate, this.cat)
      .subscribe((response: any) => {
        this.voyageList = response;
      });
  }

  close(): void {
    this.dialogref.close();
  }
}
